import { Box, Stack, Typography } from "@mui/material";
import { getPasswordStrength } from "./utils";

type PasswordStrengthProps = {
  password: string;
};

const SEGMENT_COLORS: Record<number, string> = {
  0: "divider",
  1: "error.main",
  2: "orange.contrast",
  3: "primary.main",
  4: "green.contrast",
};

const PasswordStrength = ({ password }: PasswordStrengthProps) => {
  const { color, label, score } = getPasswordStrength(password);

  return (
    <Stack spacing={0.75}>
      <Stack
        direction='row'
        spacing={0.75}>
        {Array.from({ length: 4 }, (_, index) => (
          <Box
            key={index}
            sx={{
              flex: 1,
              height: 4,
              borderRadius: 999,
              backgroundColor: index < score ? SEGMENT_COLORS[score] : "divider",
              transition: "background-color 0.2s ease",
            }}
          />
        ))}
      </Stack>

      <Typography
        variant='body14rg'
        sx={{ color }}>
        {label}
      </Typography>
    </Stack>
  );
};

export default PasswordStrength;
